import { render, staticRenderFns } from "./DatasetList.vue?vue&type=template&id=4ddbd101"
import script from "./DatasetList.vue?vue&type=script&lang=js"
export * from "./DatasetList.vue?vue&type=script&lang=js"
import style0 from "./DatasetList.vue?vue&type=style&index=0&id=4ddbd101&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports